import React, { useState, useEffect, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import styled, { css, withTheme } from "styled-components";

const StyledDropdown = styled(Dropdown)`
  .dropdown-toggle {
    background: ${(props) => props.theme?.whiteSmoke};
    box-shadow: 0px 3px 6px #0000001a;
    border-radius: 7px;
    border: 0;
    color: black;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-width: ${(props) => `${props.width || 0}px`};
    padding: 8px 15px;

    &::after {
      ${(props) =>
        props.disabled &&
        css`
          display: none;
        `}
    }
  }

  &.show > .dropdown-toggle {
    background-color: white;
    color: black;
  }

  &.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0px 3px 6px #0000001a;
  }

  .btn-primary:not(:disabled):not(.disabled):active,
  .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    background-color: white;
    color: black;
  }

  .dropdown-menu {
    box-shadow: 0px 3px 6px #0000004d;
    border-radius: 7px;
    border: 0;
    color: black;
    font-weight: 600;
    font-size: 16px;
    min-width: ${(props) => `${props.width || 0}px`};
    max-height: ${(props) => (props.limitheight ? "250px" : "none")};
    overflow-y: ${(props) => (props.limitheight ? "scroll" : "visible")};
    .dropdown-item {
      color: black;
      font-weight: 600;
      font-size: 16px;
      padding: 5px 15px;
    }
  }
`;

const CustomDropdown = (props) => {
  const {
    placeholder,
    values,
    onChange,
    width,
    disabled,
    limitheight,
    defaultValue,
    tabIndexProp,
  } = props;

  const [selected, setSelected] = useState(null);

  const onChangeCallback = (item) => {
    if (onChange) {
      onChange(item);
    }

    setSelected(item);
  };

  useEffect(() => {
    if (placeholder) {
      setSelected(null);
    }
  }, [placeholder]);

  useEffect(() => {
    if (!values?.includes(selected)) {
      setSelected(null);
    }
  }, [selected, values]);

  useEffect(() => {
    if (!selected && values && defaultValue) {
      setSelected(defaultValue);
    }
  }, [selected, defaultValue, values]);

  const getLimitHeight = useMemo(() => {
    if (limitheight) {
      return typeof limitheight === "number" ? !!limitheight : +limitheight;
    }
    return limitheight;
  }, [limitheight]);

  return (
    <StyledDropdown
      {...props}
      data-testid="custom-dropdown"
      width={width}
      limitheight={getLimitHeight}
      disabled={disabled}
    >
      <Dropdown.Toggle tabIndex={tabIndexProp} id="custom-dropdown">
        {selected?.value ?? selected ?? placeholder ?? ""}
      </Dropdown.Toggle>

      {values && values.length > 0 && (
        <Dropdown.Menu>
          {values?.map((item) => (
            <Dropdown.Item
              key={`key_${item.id ?? item}`}
              onSelect={() => onChangeCallback(item)}
            >
              {item.value ?? item}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      )}
    </StyledDropdown>
  );
};

export default withTheme(CustomDropdown);
